import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private readonly API_URL = `${environment.apiUrl}/`;

    constructor(private http: HttpClient) {}

    get(path: string, params = {}): Observable<any> {
        return this.http.get(`${this.API_URL}${path}`, { params }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    put(path: string, body = {}): Observable<any> {
        return this.http.put(`${this.API_URL}${path}`, body).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    post(path: string, body = {}, params = {}): Observable<any> {
        return this.http.post(`${this.API_URL}${path}`, body, { params }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }

    delete(path: string): Observable<any> {
        return this.http.delete(`${this.API_URL}${path}`, {}).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(error);
            })
        );
    }
}
